import React from 'react'

const Placeholder = () => (
  <div className='col-12 py-2 txt-body-sm bg-ui-4 radius' />
)

export default Placeholder



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ViewProdutOrderDetail/Placeholder.js